<template>
  <div class="col-12 card-wrapper">
    <div class="card mb-4">
      <div class="card-header">
        <h3 class="mb-0">
          <span>{{ title }}</span>

          <badge v-if="formData.state" :type="getColor()" class="float-right">
            {{ formData.state.label }}
          </badge>
        </h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <div v-if="campaign.articles && campaign.articles.length === 0" class="row mb-3">
          <div class="col-12 text-center">
            <h4 class="text-danger">La campaña seleccionada no posee articulos cargados.</h4>
          </div>
        </div>

        <!-- Form groups used in grid -->
        <form ref="form" class="needs-validation" @submit.prevent="saveQuotation">
          <quotation-info
            :campaign="campaign"
            :quotation-date="new Date()"
            :quotation-code="formData.code"
            :producer="producer"
            :projection="projection"
            :user-name="userName"
          />
          <hr />

          <div v-if="!edit && quotationOpen" class="row mb-0">
            <div class="col-3 offset-9">
              <button title="Editar" class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="edit = true">
                <i class="fas fa-pen mr-1"></i>Editar
              </button>
            </div>
          </div>

          <quotation-header v-if="!editHeader" :quotation="formData" />

          <div v-if="editHeader" class="row mt-4">
            <div class="col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="control-label"> Fecha Primer Pago (*) </label>

                <el-date-picker
                  v-model="formData.firstPaymentDate"
                  v-validate="modelValidations.firstPaymentDate"
                  align="center"
                  :editable="false"
                  format="dd-MM-yyyy"
                  name="firstPaymentDate"
                  placeholder="Fecha Primer Pago"
                  suffix-icon="fas fa-calendar-alt"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <small v-show="firstPaymentDate.invalid" class="text-danger">
                  {{ getError('firstPaymentDate') }}
                </small>
              </div>

              <div class="form-group">
                <label class="control-label"> Cantidad de Pagos (*) </label>

                <el-input
                  v-model="formData.payments"
                  v-validate="modelValidations.payments"
                  name="payments"
                  pattern="[0-9]+"
                  placeholder="Cantidad de Pagos"
                  type="number"
                >
                </el-input>

                <small v-show="payments.invalid" class="text-danger">
                  {{ getError('payments') }}
                </small>
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="control-label"> Cotización Dolar (*) </label>

                <el-input
                  v-model="formData.dollarQuote"
                  v-validate="modelValidations.dollarQuote"
                  name="dollarQuote"
                  pattern="[0-9]+([\.,][0-9]+)?"
                  placeholder="Cotización Dolar"
                  step="0.01"
                  type="number"
                >
                </el-input>

                <small v-show="dollarQuote.invalid" class="text-danger">
                  {{ getError('dollarQuote') }}
                </small>
              </div>

              <div class="form-group">
                <label class="control-label"> Observaciones </label>

                <el-input
                  v-model="formData.comment"
                  v-validate="modelValidations.comment"
                  :autosize="{ minRows: 5 }"
                  name="comment"
                  placeholder="Ingrese una observación"
                  type="textarea"
                >
                </el-input>

                <small v-show="comment.invalid" class="text-danger">
                  {{ getError('comment') }}
                </small>
              </div>
            </div>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Siguiente</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div v-if="!editHeader" class="card mb-4">
      <div class="card-body">
        <quotation-item-form
          v-if="canEditItems"
          ref="itemForm"
          :campaign="campaign"
          :quotation="quotationId"
          :projection="projection"
          @addItem="addItem"
        />
        <quotation-items-list
          v-if="hasItems"
          :add="quotationOpen"
          :dollar-quote="+formData.dollarQuote"
          :edit="canEditItems"
          :items="formData.items"
          :quotation="quotationId"
          @edit="toggleEditItems"
        />

        <div class="row mt-3">
          <div v-if="canEditItems" class="col-md-12 text-right">
            <base-button v-if="hasItems" type="primary" @click="toggleEditItems">Siguiente</base-button>
          </div>
          <div v-else-if="quotationOpen" class="col-md-12 text-right">
            <base-button v-if="hasItems" type="success" @click="confirmQuotation">Confirmar Cotización</base-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!editHeader" class="card mb-4">
      <quotation-images-list
        v-if="showPicturesList"
        :can-delete="true"
        :pictures="pictures"
        @imageDeleted="removeImage"
      />

      <quotation-images-form
        :quotation-id="quotationId"
        :picture-quantity="pictureQuantity"
        @fetchPictures="fetchPictures"
      />
    </div>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from 'element-ui';
import { mapFields } from 'vee-validate';
import QuotationHeader from '../Show/QuotationHeader';
import QuotationInfo from '../Show/QuotationInfo';
import QuotationItemForm from './QuotationItemForm';
import QuotationItemsList from '../List/QuotationItemsList';
import QuotationsService from '@/services/resources/quotations.service';
import QuotationImagesList from '../List/QuotationImagesList';
import QuotationImagesForm from './QuotationImagesForm';
import QuotationStatesMixin from '@/mixins/quotationStatesMixin';

export default {
  components: {
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [Option.name]: Option,
    QuotationInfo,
    QuotationHeader,
    QuotationItemForm,
    QuotationItemsList,
    QuotationImagesList,
    QuotationImagesForm,
  },

  mixins: [QuotationStatesMixin],
  props: {
    title: {
      type: String,
      default: 'Agregar una nueva cotización',
    },

    quotationId: {
      type: Number,
      default: 0,
    },

    producer: {
      type: Object,
      required: true,
    },

    campaign: {
      type: Object,
      required: true,
    },

    quotation: {
      type: Object,
      default: () => {
        return {
          code: null,
          date: null,
          firstPaymentDate: null,
          payments: null,
          dollarQuote: null,
          comment: null,
          state: null,
          items: [],
          pictures: [],
        };
      },
    },

    projection: {
      type: Object,
      default: null,
    },

    userName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      statesColors: [],
      edit: true,
      editItems: true,
      modelValidations: {
        firstPaymentDate: {
          required: true,
        },

        payments: {
          required: true,
          numeric: true,
        },

        dollarQuote: {
          required: true,
        },

        comment: {},
      },

      formData: {
        code: this.quotation.code,
        date: this.quotation.date || new Date(),
        firstPaymentDate: this.quotation.firstPaymentDate,
        payments: this.quotation.payments,
        dollarQuote: this.quotation.dollarQuote,
        comment: this.quotation.comment,
        state: this.quotation.state,
        items: this.quotation.items,
      },

      pictures: this.quotation.pictures,
      pictureQuantity: this.quotation.pictures.length,
    };
  },

  computed: {
    newQuotation() {
      return this.quotationId === 0;
    },

    editHeader() {
      return this.edit || this.newQuotation;
    },

    canEditItems() {
      return this.editItems && this.quotationOpen;
    },

    quotationOpen() {
      return this.formData.state !== null && this.formData.state.name === QuotationsService._STATE_OPEN;
    },

    hasItems() {
      return this.formData.items.length > 0;
    },

    ...mapFields(['firstPaymentDate', 'billingDate', 'payments', 'dollarQuote', 'comment']),
    showPicturesList() {
      return this.pictures && this.pictures.length > 0 ? true : false;
    },
  },

  mounted() {
    this.statesColors = this.$services.resource('quotation_states').getColors();
    this.edit = this.newQuotation;
  },

  methods: {
    getColor() {
      return this.statesColors[this.formData.state.id - 1];
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    getError(name) {
      return this.errors.first(name);
    },

    saveQuotation() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
          this.edit = false;
        }
      });
    },

    addItem(item) {
      this.formData.items.push(item);
      this.$refs.itemForm.clean();
    },

    toggleEditItems() {
      this.editItems = !this.editItems;
    },

    confirmQuotation() {
      this.$emit('confirm', this.formData);
    },

    fetchPictures() {
      this.$services
        .resource('quotations')
        .show(this.quotationId, { include: 'pictures' })
        .then((res) => res.data.data)
        .then((data) => this.updateQuotationPictures(data.pictures));
    },

    updateQuotationPictures(pictures) {
      this.pictures = pictures;
      this.pictureQuantity = this.pictures.length;
    },

    removeImage(index) {
      this.pictures.splice(index, 1);
      this.pictureQuantity = this.pictures.length;
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}

.see-quotation {
  margin-left: 15px;
}
</style>
